export default "__VITE_ASSET__Tjbp5jbg__"